import type { InputHTMLAttributes } from "react";
import styles from "~/styles/burn-rate.module.css";

interface InputCardProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  prefix?: string;
  suffix?: string;
}

export function InputCard({ label, prefix, suffix, className = "", ...props }: InputCardProps) {
  return (
    <label className={styles.inputCard}>
      {label && <span className={styles.inputCardLabel}>{label}</span>}
      <div className={styles.inputCardInner}>
        {prefix && <span className={styles.inputCardPrefix}>{prefix}</span>}
        <input className={`${styles.inputCardField} ${className}`} {...props} />
        {suffix && <span className={styles.inputCardSuffix}>{suffix}</span>}
      </div>
    </label>
  );
}
